/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export function processMediaApiResponse(responseArray) {
    const galleryItems = [];
    const heroItems = [];
    const previewItems = [];
    const payload = {
        galleryImages: [],
        heroImage: {},
        previewImage: {},
    };

    if (Array.isArray(responseArray)) {
        responseArray.forEach((item) => {
            const {
                is_gallery: isGallery,
                is_primary: isHero,
                is_preview: isPreview,
                title,
                description,
                url,
                credits,
                position,
            } = item;

            if (isGallery && title && url) {
                galleryItems.push({
                    altText: title,
                    caption: description,
                    url,
                    credit: credits,
                    position,
                });
            }

            if (isHero && title && url) {
                heroItems.push({
                    altText: title,
                    caption: description,
                    url,
                    credit: credits,
                });
            }

            if (isPreview && title && url) {
                previewItems.push({
                    altText: title,
                    caption: description,
                    url,
                    credit: credits,
                });
            }
        });

        galleryItems.sort((a, b) => {
            return a.position - b.position;
        });

        payload.galleryImages = galleryItems;
        payload.heroImage = heroItems[0];
        payload.previewImage = previewItems[0];
    }

    return payload;
}
